import { ListEmptyState } from "@/ds";
import type { ObrasEmptyViewModel } from "./types-obras-empty";

/** Estado vazio das duas visões: busca, filtros ou nenhuma obra cadastrada. */
export function ObrasEmptyView({ hasSearch, hasFilters, onClear }: ObrasEmptyViewModel) {
  return (
    <ListEmptyState
      noun="obra"
      gender="f"
      hasSearch={hasSearch}
      hasFilters={hasFilters}
      onClear={onClear}
      testId="obras-empty"
    />
  );
}
